<template>
    <kgr-lightbox
        :value="show"
        :headline="tHeadline"
        animated
        @post-input="closeModal"
    >
        <div class="kgr-row">
            {{ tHintText }}
        </div>

        <kgr-bookable-offering-items
            v-if="offering.salesListOfferingItems.length > 0"
            :offering-items="offering.salesListOfferingItems"
            @update:selectedSalesListOfferingItems="$emit('update:selectedSalesListOfferingItems', $event)"
        />

        <div
            v-if="showSelectableExams"
            class="kgr-row"
        >
            <hr class="kgr-separator" />
            <label
                v-for="exam in offering.clubExams"
                :key="exam.id"
                class="kgr-checkbox"
            >
                <input
                    v-model="selectedExams"
                    type="checkbox"
                    class="kgr-checkbox__control"
                    :value="exam"
                    style="margin-bottom: 10px;"
                />
                <span class="kgr-checkbox__label">{{ exam.title }}</span>
            </label>
            <hr class="kgr-separator" />
        </div>

        <div class="kgr-row">
            <button
                class="kgr-button kgr-button--secondary"
                @click="$emit('onClose')"
            >
                {{ tButtonCancel }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                :disabled="addButtonDisabled"
                @click="selectMember"
            >
                {{ tButtonExecute }}
            </button>
        </div>
    </kgr-lightbox>
</template>

<script>
import BookableOfferingItems from './BookableOfferingItems.vue';
import Lightbox from '../common/modal/Lightbox.vue';
import Offering from '../../js/dto/offering/Offering.js';

export default {
    components: {
        'kgr-bookable-offering-items': BookableOfferingItems,
        'kgr-lightbox': Lightbox,
    },
    props: {
        offering: {
            required: true,
            type: Offering,
        },
        memberId: {
            type: Number,
            required: true,
        },
        memberName: {
            type: String,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            selectedExams: [],
        };
    },
    computed: {
        tHeadline() {
            return this.$t('Teilnehmer hinzufügen');
        },
        tHintText() {
            return this.$t('offering.shouldABookingBeCreatedForMember', { name: this.memberName });
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tButtonExecute() {
            return this.$t('add');
        },
        showSelectableExams() {
            return this.offering.selectableExams && this.offering.clubExams.length > 1;
        },
        addButtonDisabled() {
            return this.loading || (this.offering.isExam() && this.selectedExams.length === 0);
        },
    },
    created() {
        this.selectedExams = this.offering.clubExams;
    },
    methods: {
        closeModal() {
            this.$emit('onClose');
        },
        selectMember() {
            const params = {};
            params.id = this.memberId;
            if (this.offering.isExam()) {
                params.selectedExams = this.selectedExams.map((exam) => exam.id);
            }
            this.$emit('selectMember', params);
        },
    },
};
</script>
